import React, { memo } from 'react';
import { Container } from './Container';
import { CustomTitle } from '@/components/CustomTitle';

export default memo(() => {
  return (
    <>
      <CustomTitle titlePrefix={'Paid Features'} />
      <Container />
    </>
  );
});
